import React from "react"
import PropTypes from "prop-types"

import happySvg from "../../images/happy-sa.svg"
import neutralSvg from "../../images/neutral-sa.svg"
import sadSvg from "../../images/sad-sa.svg"
import "./index.less"

const ICON_BY_SENTIMENT = {
  positive: happySvg,
  neutral: neutralSvg,
  negative: sadSvg,
}

// Icono de sentimiento por respuesta (ej. en QuestionCard).
export function SentimentIcon({ sentiment }) {
  if (!sentiment || !ICON_BY_SENTIMENT[sentiment]) return null

  return (
    <img
      className="SentimentIcon"
      src={ICON_BY_SENTIMENT[sentiment]}
      alt={sentiment}
    />
  )
}

SentimentIcon.propTypes = {
  sentiment: PropTypes.oneOf(["positive", "neutral", "negative"]),
}

export default SentimentIcon
